import { render, staticRenderFns } from "./LabelActions.vue?vue&type=template&id=14d45ded&scoped=true&"
import script from "./LabelActions.vue?vue&type=script&lang=js&"
export * from "./LabelActions.vue?vue&type=script&lang=js&"
import style0 from "./LabelActions.vue?vue&type=style&index=0&id=14d45ded&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d45ded",
  null
  
)

export default component.exports